import React from "react";

const PropuestaDeValorSection = () => {
  const data = [
    {
      title: "Experiencia Comprobada",
      description:
        "20+ años en SST con resultados tangibles y reconocimiento como líder en toda LATAM",
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/01/propuesta1.jpg",
    },
    {
      title: "Capacidades Globales",
      description:
        "Mi enfoque es claro: prevenir riesgos, aumentar la productividad y proteger a las personas.",
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/01/propuesta2.jpg",
    },
    {
      title: "Resultados <br> Medibles",
      description:
        "Reducción de accidentalidad, cumplimiento normativo y reconocimientos por calidad.",
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/01/propuesta3.jpg",
    },
    {
      title: "Innovación y Tecnología",
      description:
        "Implementamos soluciones de vanguardia en SST, integrando IA y automatización para maximizar la eficiencia.",
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/02/Ernesto-ia.png",
    },
  ];

  return (
    <section className="py-12 bg-black text-white">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h2
          className="text-5xl font-bold mb-8 animate-fade-in bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] bg-clip-text text-transparent"
        >
          Mi Propuesta de Valor
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {data.map((item, index) => (
            <div
              key={index}
              className="relative bg-gray-800 text-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 animate-slide-up flex flex-col justify-between h-full"
            >
              <div className="h-48 bg-gray-900">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-semibold mb-4 bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] bg-clip-text text-transparent" dangerouslySetInnerHTML={{ __html: item.title }}>
                </h3>
                <p className="text-gray-300 mb-4 flex-grow">{item.description}</p>
                <div className="mt-auto">
                  <button className="w-full bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] text-black font-bold py-2 px-4 rounded transition-shadow hover:shadow-lg hover:from-[#FFC700] hover:via-[#FFB800] hover:to-[#FFA500]">
                    {item.buttonText}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropuestaDeValorSection;
